import React, { useState } from "react";
import MediumButton from "../../../component/button/MediumButton";
import SectionContainer from "../../../Homepage/SectionContainer";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import { motion } from "framer-motion";
import VisaImg from "../../../assets/kangaroo/AustraliaBanner.jpg";
import { data } from "../data.js";
import DynamicInlineForm from "../../../component/DynamicInline/DynamicInlineForm";
import { Col, Row } from "reactstrap";
import Map from "../../../Homepage/Map.jsx";
import SmallPage from "../../../Homepage/SmallPage.jsx";
import { ChevronDown, Download, Pointer, Section, Slice } from "lucide-react";
import Destinationcountry from "../../../services/Destinationcountry.js";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import MainForm from "../component/MainForm.jsx";
import { imageBaseApi } from "../../../services/imageBaseApi.js";
import { div } from "framer-motion/client";
import Professional from "../../../Homepage/Professional.jsx";
import Form from "../../../component/Form/Form.jsx";
const ServicePage = () => {
  const oshcData = data;
  const { section } = useParams();
  const [isHovered, setIsHovered] = React.useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const fetchData = async (section) => {
    const response = await Destinationcountry.getbySlug(section);
    return response;
  };

  const {
    isPending,
    error,
    data: serviceData,
  } = useQuery({
    queryKey: ["serviceData", section],
    queryFn: ({ queryKey }) => {
      const [, section] = queryKey;
      return fetchData(section);
    },
  });

  if (isPending) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  console.log("serviceData:", serviceData);
  console.log("subDetails:", serviceData?.subDetails);
  console.log("subDetails length:", serviceData?.subDetails?.length);

  return (
    <>
      <div
        className="hero-banner"
        style={{
          "--banner-img": `url(${imageBaseApi + serviceData?.bannerMedia?.url || VisaImg
            })`,
          overflow: "hidden",
        }}
      >
        <SectionContainer >
          <BreadCrumb
            items={[
              { title: "HOME", link: "/" },
              { title: "SERVICES", link: "/services" },
              { title: serviceData?.name },
            ]}
            country={true}
            instituition={true}
          />
          <div className=" page-content text-start h-100 d-flex flex-column justify-content-center">
            <h1
              className="banner-text-country lh-1"
              style={{ color: serviceData?.bannerTextColorCode }}
            >
              {serviceData?.bannerText}


            </h1>
            <div onClick={toggleModal}>
              <MediumButton
                label={serviceData?.bannerButtonText}
                career={true}
                fill="transparent"
                textColor={serviceData?.bannerButtonColorCode}
                strokeColor="#fff"
                width={250}
                height={80}
                fontSize={24}
              />
            </div>
          </div>
        </SectionContainer>
      </div>
      <SectionContainer>
        <p
          className="country-paragraph-text"
          dangerouslySetInnerHTML={{ __html: serviceData?.mainDescription }}
        />
        {/* <h1 className='font-level-8'style={{marginTop:"71px", marginBottom:"31px"}}>{serviceData?.subDetails[0].title}</h1>
          <p
    className="country-paragraph-text"
    dangerouslySetInnerHTML={{ __html: serviceData?.subDetails[0].description }}
  /> */}
        {serviceData?.subDetails
          ?.slice(0, 1)
          ?.map((subDetail, subDetailIndex) => (
            <div key={subDetail.id} className="mb-12">
              <h1
                className="font-level-8"
                style={{ marginTop: "63px", marginBottom: "38px" }}
              >
                {subDetail.title}
              </h1>
              {subDetail?.description && (
                <p
                  className="country-paragraph-text"
                  dangerouslySetInnerHTML={{ __html: subDetail.description }}
                />
              )}

              {subDetail.subDetailsMenus?.map((menu, menuIndex, menuArr) => (
                <React.Fragment key={menu.id}>
                  <hr className="line-visa" style={{margin:0}} />

                  <div
                    className="d-flex align-items-center gap-2 py-3 hover-item" style={{
                      cursor:"Pointer"
                      
                    }}
                    onClick={() =>
                        handleToggle(`${subDetailIndex}-${menuIndex}`)
                      }
                    
                  >
                    <div
                      onClick={() =>
                        handleToggle(`${subDetailIndex}-${menuIndex}`)
                      }
                      style={{
                        display: "inline-block",
                        transition: "transform 0.3s ease, color 0.3s ease",
                        transform:
                          openIndex === `${subDetailIndex}-${menuIndex}`
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                        color:
                          openIndex === `${subDetailIndex}-${menuIndex}`
                            ? "#83168F"
                            : "#ff4d1d",
                        cursor: "pointer",
                      }}
                    >
                      <ChevronDown size="2.5rem" />
                    </div>

                    <pre
                      className={`m-0 p-0 ${openIndex === `${subDetailIndex}-${menuIndex}`
                          ? "dropdown-heading"
                          : "country-paragraph-text"
                        }`}
                      style={{ overflow: "hidden" }}
                    >
                      {menu.title}
                    </pre>
                  </div>

                  {openIndex === `${subDetailIndex}-${menuIndex}` && (
                    <div
                      className="d-flex flex-column"
                      style={{ marginLeft: "3.1rem" }}
                    >
                      {/* Menu Description */}
                      {menu.description && (
                        <div
                          className="text-black mb-3"
                          dangerouslySetInnerHTML={{ __html: menu.description }}
                        />
                      )}

                      {/* Contents */}
                      {menu.contents?.map((content, contentIndex) => (
                        <div key={content.id} className="mb-4">
                          {/* Content Heading */}
                          {content.heading && (
                            <h1 className="dropdown-font">{content.heading}</h1>
                          )}

                          {/* Content SubHeading */}
                          {content.subHeading && (
                            <h2 className="dropdown-font-sub">
                              {content.subHeading}
                            </h2>
                          )}

                          {/* Content Description */}
                          {content.description && (
                            <div
                              className="text-black mb-3"
                              dangerouslySetInnerHTML={{
                                __html: content.description,
                              }}
                            />
                          )}

                          {/* Content Image */}
                          {content.media?.url && (
                            <div
                              style={{
                                height: "350px",
                                width: "100%",
                                overflow: "hidden",
                              }}
                            >
                              <img
                                src={imageBaseApi + content.media.url}
                                alt={
                                  content.media.fileName ||
                                  content.heading ||
                                  "Content image"
                                }
                                className="rounded-5 w-100"
                                style={{
                                  height: "100%",
                                  width: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          )}

                          {/* Content PDF */}
                          {content.pdf?.url && (
                            <a
                              href={content.pdf.url}
                              download={content.pdf.fileName}
                              className="btn btn-outline-primary mb-3"
                            >
                              Downloads {content.pdf.fileName}
                            </a>
                          )}
                        </div>
                      ))}

                      {/* Download Buttons */}
                      <div className="d-flex gap-5 my-5">
                        {menu.pdf?.url && (
                          <motion.button
                            className="rounded-full navbar-btn-font px-3"
                            style={{
                              backgroundColor: "white",
                              width: "max-content",
                              height: "45px",
                              position: "relative",
                              overflow: "hidden",
                              cursor: "pointer",
                              borderRadius: "50px",
                              border: "2px solid #FF4D1D",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                            whileHover="hover"
                            onClick={() => window.open(menu.pdf.url, "_blank")}
                          >
                            <motion.div
                              style={{
                                position: "absolute",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                background:
                                  "linear-gradient(to right, #83168F, #D40B84)",
                                zIndex: 0,
                              }}
                              initial={{ x: "-100%" }}
                              variants={{ hover: { x: 0 } }}
                              transition={{ duration: 0.5, ease: "easeInOut" }}
                            />

                            <div
                              style={{
                                position: "relative",
                                zIndex: 1,
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <motion.div
                                initial={{ color: "#7e1790" }}
                                variants={{
                                  hover: {
                                    color: "#fff",
                                    transition: { duration: 0.5 },
                                  },
                                }}
                                style={{
                                  display: "inline-flex",
                                  marginRight: "1rem",
                                }}
                              >
                                <Download />
                              </motion.div>

                              <motion.span
                                style={{ color: "#7e1790" }}
                                initial={{ color: "#7e1790" }}
                                variants={{
                                  hover: {
                                    color: "#fff",
                                    transition: { duration: 0.5 },
                                  },
                                }}
                              >
                                DOWNLOAD PDF
                              </motion.span>
                            </div>
                          </motion.button>
                        )}
                      </div>
                    </div>
                  )}

                  {menuIndex === menuArr.length - 1 && (
                    <hr className="line-visa" style={{margin:0}} />
                  )}
                </React.Fragment>
              ))}
            </div>
          ))}
      </SectionContainer>
      <div className="mt-5">

      <MainForm params={section} />
      </div>
      {section === "education" && (
        <SectionContainer>
          <div
            style={{ marginTop: "10rem", marginBottom: "10rem" }}
            className="p-0 mx-0"
          >
            <Professional />
          </div>
        </SectionContainer>
      )}
      <SectionContainer>
        {serviceData?.subDetails?.slice(1)?.map((subDetail, subDetailIndex) => (
          <div key={subDetail.id} className="mb-12">
            <h1
              className="font-level-8"
              style={{ marginTop: "63px", marginBottom: "38px" }}
            >
              {subDetail.title}
            </h1>
            {subDetail?.description && (
              <p
                className="country-paragraph-text"
                dangerouslySetInnerHTML={{ __html: subDetail.description }}
              />
            )}

            {subDetail.subDetailsMenus?.map((menu, menuIndex, menuArr) => (
              <React.Fragment key={menu.id}>
                <hr className="line-visa" style={{margin:0}} />

                <div className="d-flex align-items-center gap-2 py-3 hover-item" style={{
                  cursor:"pointer"
                }}
                onClick={() =>
                      handleToggle(`${subDetailIndex}-${menuIndex}`)
                    }>
                  <div
                    onClick={() =>
                      handleToggle(`${subDetailIndex}-${menuIndex}`)
                    }
                    style={{
                      display: "inline-block",
                      transition: "transform 0.3s ease, color 0.3s ease",
                      transform:
                        openIndex === `${subDetailIndex}-${menuIndex}`
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                      color:
                        openIndex === `${subDetailIndex}-${menuIndex}`
                          ? "#83168F"
                          : "#ff4d1d",
                      cursor: "pointer",
                    }}
                  >
                    <ChevronDown size="2.5rem" />
                  </div>

                  <pre
                    className={`m-0 p-0 ${openIndex === `${subDetailIndex}-${menuIndex}`
                        ? "dropdown-heading"
                        : "country-paragraph-text"
                      }`}
                    style={{ overflow: "hidden" }}
                  >
                    {menu.title}
                  </pre>
                </div>

                {openIndex === `${subDetailIndex}-${menuIndex}` && (
                  <div
                    className="d-flex flex-column"
                    style={{ marginLeft: "3.1rem" }}
                  >
                    {/* Menu Description */}
                    {menu.description && (
                      <div
                        className="text-black mb-3"
                        dangerouslySetInnerHTML={{ __html: menu.description }}
                      />
                    )}

                    {/* Contents */}
                    {menu.contents?.map((content, contentIndex) => (
                      <div key={content.id} className="mb-4">
                        {/* Content Heading */}
                        {content.heading && (
                          <h1 className="dropdown-font">{content.heading}</h1>
                        )}

                        {/* Content SubHeading */}
                        {content.subHeading && (
                          <h2 className="dropdown-font-sub">
                            {content.subHeading}
                          </h2>
                        )}

                        {/* Content Description */}
                        {content.description && (
                          <div
                            className="text-black mb-3"
                            dangerouslySetInnerHTML={{
                              __html: content.description,
                            }}
                          />
                        )}

                        {/* Content Image */}
                        {content.media?.url && (
                          <div
                            style={{
                              height: "350px",
                              width: "100%",
                              overflow: "hidden",
                            }}
                          >
                            <img
                              src={imageBaseApi + content.media.url}
                              alt={
                                content.media.fileName ||
                                content.heading ||
                                "Content image"
                              }
                              className="rounded-5 w-100"
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        )}

                        {/* Content PDF */}
                        {content.pdf?.url && (
                          <a
                            href={content.pdf.url}
                            download={content.pdf.fileName}
                            className="btn btn-outline-primary mb-3"
                          >
                            Downloads {content.pdf.fileName}
                          </a>
                        )}
                      </div>
                    ))}

                    {/* Download Buttons */}
                    <div className="d-flex gap-5 my-5">
                      {menu.pdf?.url && (
                        <motion.button
                          className="rounded-full navbar-btn-font px-3"
                          style={{
                            backgroundColor: "white",
                            width: "max-content",
                            height: "45px",
                            position: "relative",
                            overflow: "hidden",
                            cursor: "pointer",
                            borderRadius: "50px",
                            border: "2px solid #FF4D1D",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          whileHover="hover"
                          onClick={() => window.open(menu.pdf.url, "_blank")}
                        >
                          <motion.div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              background:
                                "linear-gradient(to right, #83168F, #D40B84)",
                              zIndex: 0,
                            }}
                            initial={{ x: "-100%" }}
                            variants={{ hover: { x: 0 } }}
                            transition={{ duration: 0.5, ease: "easeInOut" }}
                          />

                          <div
                            style={{
                              position: "relative",
                              zIndex: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <motion.div
                              initial={{ color: "#7e1790" }}
                              variants={{
                                hover: {
                                  color: "#fff",
                                  transition: { duration: 0.5 },
                                },
                              }}
                              style={{
                                display: "inline-flex",
                                marginRight: "1rem",
                              }}
                            >
                              <Download />
                            </motion.div>

                            <motion.span
                              style={{ color: "#7e1790" }}
                              initial={{ color: "#7e1790" }}
                              variants={{
                                hover: {
                                  color: "#fff",
                                  transition: { duration: 0.5 },
                                },
                              }}
                            >
                              DOWNLOAD PDF
                            </motion.span>
                          </div>
                        </motion.button>
                      )}
                    </div>
                  </div>
                )}

                {menuIndex === menuArr.length - 1 && (
                  <hr className="line-visa" style={{margin:0}} />
                )}
              </React.Fragment>
            ))}
          </div>
        ))}
        <Form
          modal={modalOpen}
          toggle={toggleModal}
          heading=" Get the Guidance you Need"
          description=" Share a few details and we'll help you move forward with your study plans for this destination."
          additionalField={false}
          aus={true}
          isAppointment={true}
          closingMessage="YOU'RE ONE STEP CLOSER TO STARTING SMART"
          closingDesc="Our counselor will connect with you shortly"
        />
      </SectionContainer>

      <hr className="line" />
      <SectionContainer>
        <Map />
        <hr className="line-style-testprep" />
        <SmallPage countryPage={true} />
      </SectionContainer>
    </>
  );
};

export default ServicePage;
